<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-aqua"><i class="ion ion-social-yen"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">昨日订单金额</span>
            <span class="info-box-number">
              <small>￥</small>
              <span v-text="yesterdayOrderAmt">90</span>
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-red"><i class="fa ion-ios-list-outline"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">昨日订单总量</span>
            <span class="info-box-number" v-text="yesterdayOrderCnt"></span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->

      <!-- fix for small devices only -->
      <div class="clearfix visible-sm-block"></div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-green"><i class="ion ion-person-stalker"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">昨日新增用户数</span>
            <span class="info-box-number" v-text="yesterdayUserCnt"></span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-yellow"><i class="ion ion-pie-graph"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">累计订单金额</span>
            <span class="info-box-number">
              <small>￥</small>
              <span v-text="totalOrderAmt"></span>
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title"></h3>
            <div class="box-body">
              <div class="col-sm-6 col-xs-12">
                <p class="text-center">
                  <strong>7日订单变化</strong>
                </p>
                <canvas id="trafficBar" ></canvas>
              </div>
              <hr class="visible-xs-block">
              <div class="col-sm-6 col-xs-12">
                <p class="text-center">
                  <strong>用户性别占比</strong>
                </p>
                <canvas id="languagePie"></canvas>
              </div>
            </div>
          </div>
          <small class="space"></small>
          <div class="clearfix"> </div>
        </div>
        <div class="clearfix"> </div>
      </div>
    </div>
    <!-- /.row -->

    <!-- 
    <div class="row">
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box bg-yellow">
          <span class="info-box-icon"><i class="ion ion-ios-pricetag-outline"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Inventory</span>
            <span class="info-box-number">5,200</span>

            <div class="progress">
              <div class="progress-bar" style="width: 50%"></div>
            </div>
                <span class="progress-description">
                  50% Increase
                </span>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box bg-green">
          <span class="info-box-icon"><i class="ion ion-ios-heart-outline"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Mentions</span>
            <span class="info-box-number">92,050</span>

            <div class="progress">
              <div class="progress-bar" style="width: 20%"></div>
            </div>
                <span class="progress-description">
                  20% Increase
                </span>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box bg-red">
          <span class="info-box-icon"><i class="ion ion-ios-cloud-download-outline"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Downloads</span>
            <span class="info-box-number">114,381</span>

            <div class="progress">
              <div class="progress-bar" style="width: 70%"></div>
            </div>
                <span class="progress-description">
                  70% Increase
                </span>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="info-box bg-aqua">
          <span class="info-box-icon"><i class="ion-ios-chatbubble-outline"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Direct Messages</span>
            <span class="info-box-number">163,921</span>

            <div class="progress">
              <div class="progress-bar" style="width: 40%"></div>
            </div>
                <span class="progress-description">
                  40% Increase
                </span>
          </div>
        </div>
      </div>
    </div>
    -->
  </section>
  <!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import portalService from '../../service/portal.js'

export default {
  data () {
    return {
      yesterdayOrderCnt: 0,
      yesterdayOrderAmt: 0,
      yesterdayUserCnt: 0,
      totalOrderAmt: 0,

      labels: [],
      saleNums: [],
      maleRatio: 40,
      femaleRatio: 40,
      unknownRatio: 20
    }
  },
  computed: {

    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  mounted () {
    this.portalService = new portalService.PortalService()
    let that = this
    this.portalService.loadOverviewData(function (data) {
      that.yesterdayOrderCnt = data.yesterday_order_cnt
      that.yesterdayOrderAmt = data.yesterday_order_amt
      that.yesterdayUserCnt = data.yesterday_user_cnt
      that.totalOrderAmt = data.total_order_amt

      that.labels = data.date_labels
      that.saleNums = data.order_cnts
      that.maleRatio = data.male_ratio
      that.femaleRatio = data.female_ratio
      that.unknownRatio = data.unknown_ratio

      that.$nextTick(() => {
        var ctx = document.getElementById('trafficBar').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: that.labels,
            datasets: [{
              label: '订单数量',
              fill: false,
              borderColor: '#284184',
              pointBackgroundColor: '#284184',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: that.saleNums
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !that.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }

        new Chart(ctx, config) // eslint-disable-line no-new

        var pieChartCanvas = document.getElementById('languagePie').getContext('2d')
        var pieConfig = {
          type: 'pie',
          data: {
            labels: ['男', '女', '未知'],
            datasets: [{
              data: [that.maleRatio, that.femaleRatio, that.unknownRatio],
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !that.isMobile,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        }

        new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
      })
    })
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?6ccf6d5d